// ================================================================
// Prompts Store — مرکز پرامپت صنفی (نسخه‌ی backend)
// ================================================================
// به API /api/prompts وصل می‌شه. همه‌ی توابع async هستن.
// ساختار نسخه از سرور: { id, trade, text, isActive, createdAt }

import { apiRequest } from './apiClient.js';

// لیست صنف‌ها — منبع واحد (پنل + نود AI)
export const TRADES = [
  { key: 'glaser',       labelKey: 'trades.glaser' },
  { key: 'maler',        labelKey: 'trades.maler' },
  { key: 'elektriker',   labelKey: 'trades.elektriker' },
  { key: 'sanitaer',     labelKey: 'trades.sanitaer' },
  { key: 'schreiner',    labelKey: 'trades.schreiner' },
  { key: 'plattenleger', labelKey: 'trades.plattenleger' },
  { key: 'heizung',      labelKey: 'trades.heizung' },
  { key: 'dachdecker',   labelKey: 'trades.dachdecker' },
  { key: 'andere',       labelKey: 'trades.andere' }
];

// نسخه‌های یک صنف (جدیدترین اول) — آرایه‌ای از { id, trade, text, isActive, createdAt }
export async function getVersions(tradeKey) {
  const data = await apiRequest('/api/prompts?trade=' + encodeURIComponent(tradeKey));
  return data.versions || [];
}

// صنف‌هایی که حداقل یک نسخه دارن — آرایه‌ای از کلیدها
export async function getTradesWithVersions() {
  const data = await apiRequest('/api/prompts/trades');
  return data.trades || [];
}

// ساخت نسخه‌ی جدید
export async function saveVersion(tradeKey, text) {
  const data = await apiRequest('/api/prompts', {
    method: 'POST',
    body: JSON.stringify({ trade: tradeKey, text: String(text) })
  });
  return data.version;
}

// فعال‌کردن یک نسخه
export async function setActive(id) {
  return apiRequest('/api/prompts/' + encodeURIComponent(id) + '/activate', { method: 'POST' });
}

// انتقال به سطل
export async function moveToTrash(id) {
  return apiRequest('/api/prompts/' + encodeURIComponent(id), { method: 'DELETE' });
}

// بازیابی از سطل
export async function restoreVersion(id) {
  return apiRequest('/api/prompts/' + encodeURIComponent(id) + '/restore', { method: 'POST' });
}

// حذف دائمی
export async function purgeVersion(id) {
  return apiRequest('/api/prompts/' + encodeURIComponent(id) + '/purge', { method: 'DELETE' });
}

// کل سطل (همه‌ی صنف‌ها) — آرایه‌ای از { id, trade, text, createdAt, deletedAt }
export async function getAllTrash() {
  const data = await apiRequest('/api/prompts/trash');
  return data.items || [];
}
